export default "__VITE_ASSET__BMkDLvap__"